<template>
  <div class="contentBox">
    <navBox :id="navId" ref="navBox"></navBox>
    <!-- 列表 -->
    <div class="content">
      <myHeader ref="myHeader"></myHeader>
      <!-- 添加 -->
      <div class="MobelBox" v-if="addType" v-loading="loading" :element-loading-text="loadTxt">
        <p class="title">{{addType=='add'?'添加':'编辑'}}</p>
        <form>
          <div class="write-txt">
            <p class="write-title">
              大标题<span>*</span>
            </p>
            <div class="write-text">
              <!-- <input type="number" v-model="addObj.version"> -->
              <textarea v-model="addObj.title"></textarea>
            </div>
          </div>
          <div class="write-txt">
            <p class="write-title">
              正文<span>*</span>
            </p>
            <div class="write-text">
              <!-- <input type="text" v-model="addObj.content"> -->
              <!-- <textarea v-model="addObj.content"></textarea> -->
              <myEditor v-model="addObj.content" />
            </div>
          </div>
          <div class="write-txt">
          <p class="write-title">上传图片<span>*</span></p>
          <div class="write-text">
            <div class="img" @mouseenter="imgShow" @mouseleave="imgHide" v-if="addObj.image">
              <img :src="'https://speakiopic.zens10.com/'+addObj.image" alt="">
              <div class="hover" v-if="imgType">
                <i class="icon-delete" @click="imgRemove"></i>
              </div>
            </div>
            <el-upload
              :action="'https://up-as0.qiniup.com'"
              :data="uploadObj"
              list-type="picture-card"
              :before-upload="beforeUpload"
              :on-success="handleSuccess"
              :on-progress="handleProgressImg"
              :on-remove="handleRemove"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">
              <img
                width="100%"
                :src="'https://speakiopic.zens10.com/' + addObj.image"
                alt=""
              />
            </el-dialog>
          </div>
        </div>
        </form>
        <div class="btnBox">
          <button class="btn btn-sub" @click="saveSub">确认</button>
          <button class="btn btn-close" @click="closeSub">取消</button>
        </div>
      </div>
      <div class="organiza-txt" v-else>
        <div class="organiza-title clear">
          <div class="organiza-left" @click="addSub">
            <img src="~@/assets/images/icon-add.png" alt="">
            <p>添加</p>
          </div>
        </div>
        <div class="organiza-list">
          <div class="titleList">
            <p v-for="item in titleList" v-bind:key="item.id">{{item.title}}</p>
          </div>
          <div class="dataList">
            <div class="listItem" v-for="(item,index) in dataList" v-bind:key="(index+1)">
              <p :title="item.id">{{item.id}}</p>
              <p :title="item.title">{{item.title}}</p>
              <p :title="item.content">{{item.content}}</p>
              <p>
                <el-switch
                  @change="switchChange(item)"
                  v-model="item.publish_status"
                  active-color="#457AFF"
                  inactive-color="#CBCBCB">
                </el-switch>
              </p>
              <p :title="item.create_time">{{item.create_time}}</p>
              <p>
                <button title="编辑" class="btn btn-revise" @click="buildSub(item)"></button>
                <!-- <button title="删除" @click="removeShow(item)" class="btn btn-remove"></button> -->
              </p>
            </div>
          </div>
          
          <div class="block pageBox clear">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="obj.page"
              :page-size="1"
              layout="prev, pager, next, jumper"
              :total="totalPage">
            </el-pagination> 
          </div>
        </div>
      </div>

      
    </div>

    <div class="msgBox" v-if="removeType">
      <div class="contv" style="height: auto;">
        <p class="title">是否确定删除？</p>
        <div class="btnBox">
          <button class="btn btn-close" @click="closeSub">取消</button>
          <!-- <button class="btn btn-sub" @click="removeSub">确定</button> -->
        </div>
      </div>
    </div>

    
  </div>
</template>

<script>

import { getNoticeList, saveNotice ,getNoticeDetail,getUploadToken,updateNoticeStatus} from "@/assets/js/api";
import navBox from './../components/comment/nav.vue';
import myHeader from './../components/comment/myHeader.vue';
import myEditor from "./../components/comment/wangeditor.vue";
export default {
  name: "contentIndex",
  data() {
    return {
      navId:'18',
      titleList:[
        {id:2,title:'序号'},
        {id:3,title:'大标题'},
        {id:4,title:'正文'},
        {id:6,title:'是否上架'},
        {id:5,title:'添加时间'},
        {id:1,title:'操作'},
      ],
      dataList:[
      ],
      addType:'',
      removeType:false,
      obj:{
        page:1,
        rows:10,
      },
      addObj:{
        title:'',
        image:'',
        content:''
      },
      totalPage:0,
      token:'',
      removeID:'',
      imgType:false,
      uploadObj: {
        token: "",
        key: "",
      },
      loading:false,
      loadTxt:'',
      dialogVisible:false
    };
  },
  components: {
    navBox,
    myHeader,
    myEditor
  },
  mounted(){
    this.token = localStorage.getItem('token');
    this.getList();
    this.getToken();
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.getList();
    },

    async getToken(){
      var that = this;
      try {
        const response = await getUploadToken(this.token);
        if(response.code == 200){
          that.uploadObj.token = response.data.token
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      };
    },

    searchSub(){
      this.obj.page = 1;
      this.dataList = [];
      this.getList();
    },

    resetSub(){
      this.obj = {
        page:1,
        rows:10,
        
      };
      this.addObj = {
        title:'',
        image:'',
        content:''
      }
      this.dataList = [];
      this.getList();
    },

    

    async getList(){
      var that = this;
      try {
        const response = await getNoticeList(this.obj,this.token);
        if(response.code == 200){
          response.data.list.forEach(function(item,index){
            if(item.publish_status==0){
              item.publish_status=false
            } else {
              item.publish_status=true
            }
          })
          that.dataList = response.data.list;
          that.totalPage = response.data.total_page;    
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    async switchChange(e){
      var that = this;
      var obj = {
        id:e.id,
        publish_status:e.publish_status==false?0:1,
      };
      try {
        const response = await updateNoticeStatus(obj,this.token);
        if(response.code == 200){
          that.$message('发布状态修改成功！');
          that.getList();      
        } else {
          that.$message(response.msg);
          e.publish_status = !e.publish_status;
        }
      } catch (error) {
        that.$message(error);
        e.publish_status = !e.publish_status;
      }
    },

    addSub(){
      this.addType = 'add';
    },

    async saveSub(){
      var that = this;
      
      if(this.addObj.title == ''){
        that.$message('请输入标题！');
        return false;
      }
      if(this.addObj.content == ''){
        that.$message('请输入正文！');
        return false;
      }
      if(this.addObj.image == ''){
        that.$message('请上传图片！');
        return false;
      }
      try {
        const response = await saveNotice(this.addObj,this.token);
        if(response.code == 200){
          that.$message('成功');
          that.addType = '';
          that.resetSub(); 
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    async buildSub(e){
      var that = this;
      try {
        const response = await getNoticeDetail({id:e.id},this.token);
        if(response.code == 200){
          that.addObj = response.data;
          that.addType = 'revise';
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    removeShow(e){
      var that = this;
      this.removeType = true;
      this.removeID = e.id;
    },

    // async removeSub(e){
    //   var that = this;
    //   try {
    //     const response = await delAppUpdate({id:this.removeID},this.token);
    //     if(response.code == 200){
    //       that.$message('成功');
    //       that.removeType = '';
    //       that.resetSub();
    //     } else {
    //       that.$message(response.msg);
    //     }
    //   } catch (error) {
    //     that.$message(error);
    //   }
    // },

    closeSub(){
      this.removeType = false;
      this.addType = '';
      this.addObj = {
        title:'',
        image:'',
        content:''
      };
      this.removeID = '';
    },

    imgShow(){
      this.imgType = true;
    },

    imgHide(){
      this.imgType = false;
    },

    imgRemove(){
      this.addObj.image = '';
    },

    beforeUpload(file) {
      this.loading = true;
      this.uploadObj.key = file.uid + file.name; // key为上传后文件名 必填
    },

    handleProgressImg(event, file, fileList) {
      this.loadTxt = "已上传" + file.percentage.toFixed(0) + "%";
    },

    handleSuccess(response, file, fileList) {
      this.addObj.image = response.key;
      this.loading = false;
      this.uploadObj.key = "";
    },

    handleRemove(response, file, fileList,index) {
      this.addObj.image = "";
    },

    imgUpload(type){
      console.log('2')
    }
  }

  
};
</script>
<style scoped>
  .dataList .listItem p, 
  .organiza-list p{
    width: calc( 100% / 6 );
  }

  .dataList .listItem p{
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .btn-remove,
  .btn-revise{
    background-image: url(~@/assets/images/btn-revise.png);
    width: 22px;
    height: 22px;
    background-size: 22px 22px;
    display: inline-block;
    vertical-align: top;
  }

  .btn-remove{
    background-image: url(~@/assets/images/btn-remove.png);
    margin-left: 20px;
  }

  .MobelBox{
    margin: 20px;
    box-sizing: border-box;
    width: 100%;
    height: calc( 100% - 120px );
  }

  .MobelBox form{
    background-color: #fff;
    padding: 30px;
    box-sizing: border-box;
  }

  .MobelBox .write-txt{
    display: block;
    width: 100%;
    margin-bottom: 20px;
  }

  .MobelBox .write-title{
    font-size: 18px;
    color: #333333;
    display: inline-block;
    vertical-align: top;
    width: 200px;
  }

  .MobelBox .write-title span{
    color: #E2231A;
  }

  .MobelBox .write-text{
    display: inline-block;
    vertical-align: top;
    width: 80%;
    margin-left: 20px;
  }

  .MobelBox .write-text span{
    font-size: 14px;
    color: #E2231A;
    margin-top: 10px;
    display: block;
  }

  .MobelBox input,
  .MobelBox textarea{
    width: 80%;
    height: 65px;
    background-color: #F5F5F5;
    border-radius: 16px;
    display: block;
    padding: 10px;
    box-sizing: border-box;
  }

  .MobelBox textarea{
    height: 300px;
  }

  .MobelBox input{
    width: 360px;
    height: 65px;
  }

  .MobelBox input.vip_time{
    display:inline-block;
    width: 120px;
    padding: 0 10px;
    margin-right: 20px;
  }

  .MobelBox .btnBox{
    display: block;
    margin-top: 30px;
    text-align: right;
    margin-right: 40px;
  }

  .MobelBox .btnBox .btn{
    font-size: 20px;
    color: #999999;
    box-sizing: border-box;
    padding: 14px 40px;
    border-radius: 16px;
    display: inline-block;
    vertical-align: top;
    background-color: #F9F9F9;
  }

  .MobelBox .btnBox .btn.btn-sub{
    background-color: #6E2FFF;
    color: #fff;
    margin-right: 40px;
  }

  .write-btnBox{
    float: right;
    width: 100%;
    text-align: right;
  }

  .write-btnBox .btn{
    width: 120px;
    height: 56px;
    line-height: 56px;
    border-radius: 16px;
    color: #fff;
    background-color: #6E2FFF;
    padding: 0;
    margin: 0;
    font-size: 20px;
  }

  .write-btnBox .btn.btn-close{
    color: #999999;
    background-color: #F5F5F5;
    margin-left: 40px;
  }

  .msgBox .contv{
    padding: 40px 73px;
    border-radius: 32px;
  }

  .msgBox .title {
    text-align: center;
    margin-bottom: 50px;
  }

  .searchBox>>>.search-item input{
    width: 160px;
  }

  .msgBox .contv{
    height: 80%;
  }

  .msgBox .btnBox{
    margin-top: 50px;
  }

  .msgBox>>>.el-radio__label{
    font-size: 15px;
  }
  .msgBox>>>.el-radio-group .el-radio{
    line-height: 30px;
  }

  .write-txt>>> .el-radio__inner{
    width: 20px;
    height: 20px;
  }

  .write-txt>>> .el-radio__inner::after{
    width: 10px;
    height: 10px;
  }

  .write-txt>>> .el-radio__label{
    font-size: 18px;
    vertical-align: top;
  }

  .write-txt>>> .el-radio-group{
    display: inline-block;
    vertical-align: top;
    line-height: 65px;
  }
</style>



// WEBPACK FOOTER //
// src/content/index.vue